import { Box, Text, Image } from 'rebass';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Modal from 'app/modal/v3/index';
import { useMobileCheckHook } from 'story-media/hooks';
import milestones from 'app/navigation/sidebar/assets/milestones.png';
import watchMeGrow from 'app/navigation/sidebar/assets/watchMeGrow.png';
import threebookswithPrice from 'gift-certificate/assets/threebookswithPrice.png';
import useRouteFromEntityParams from 'collections/hooks/route-from-entity-params';


const FetaureComingSoon = () => {
  const { type, id, feature_name } = useParams()
  const { replace } = useHistory();
  const isFromMobile = useMobileCheckHook()
  const route = useRouteFromEntityParams({ type, id });

  function getFeatureSoonSubTitle() {
    if (feature_name === 'Milestones')
      return "Capture and date precious moments along your child's journey, showcased on a dedicated milestones page in your book."
    if (feature_name === 'My-Book')
      return "Select from many book colors, cover templates and page designs for your baby book."
    if (feature_name === 'Watch-Me-Grow')
      return "Add a photo and short video each month to create a stunning progress page for your book or a framed print, with QR codes linking each photo to its video."
  }

  function getFeatureSoonTitle() {
    if (feature_name === 'Milestones')
      return "Milestones"
    if (feature_name === 'My-Book')
      return "My Book"
    if (feature_name === 'Watch-Me-Grow')
      return "Watch Me Grow"
  }

  function getFeatureSoonImage() {
    if (feature_name === 'Milestones')
      return milestones
    if (feature_name === 'My-Book')
      return threebookswithPrice
    if (feature_name === 'Watch-Me-Grow')
      return watchMeGrow
  }

  return <Modal
    // title="Feature coming soon!"
    // style={{ height: '100vh', background: '#fff' }}
    maxWidth={400}
    closeButton
    close={{
      onClose: () => {
        replace(route)
      }
    }}
    // aboveTooltip
    closeOnOutsideClick
    isScrollActive={!isFromMobile}
  >
    <Box bg="white" p={3} pt={0}>
      <Text fontFamily="Bitter" textAlign="center" color="#000" fontSize={30} lineHeight="165%">Feature coming soon!</Text>
      <Box m="auto" my={2} backgroundColor='rgba(0, 0, 0, 0.05)' height="1px" maxWidth="90%" />
      <Text fontFamily="Poppins" fontSize="18px" fontWeight={500} lineHeight="165%">{getFeatureSoonTitle()}</Text>
      <Image my={3} src={getFeatureSoonImage()} />
      <Text color="#64748B" fontFamily="Poppins" fontSize="18px" letterSpacing="0.36px" lineHeight="150%">
        {getFeatureSoonSubTitle()}
      </Text>
    </Box>
  </Modal>
  {/* {closeModal && <ConfirmationModal
      message="Are you sure you want to cancel this story request?"
      deleteLabel="Cancel story Request"
      onCancel={() => setCloseModal(false)}
      onConfirm={() => {
        replace(`${route}`)
      }}
    />}
    <Box sx={{
      position: 'absolute',
      height: step === 4 ? `100vh` : [`calc(100vh - 150px)`, `calc(100vh - 50px)`],
      width: '100%',
      overflowY: 'scroll',
      maxWidth: 500,
      '-webkit-overflow-scrolling': 'touch',
      touchAction: 'auto',
      mt: 2
    }}>
      <SectionRender isStillAlive={memoir?.['subject-alive']} subjectRelation={memoir?.['subject-relation']} feature_name={feature_name} replace={replace} memoirId={id} type={type} step={step} onStepUp={onStepUp} onStepDown={onStepDown} />
    </Box> */}
  {/* </Modal> */ }
};

FetaureComingSoon.propTypes = {

};

export default FetaureComingSoon;
